import Component from '@glimmer/component';
import { type ActionVariant, buttonStyles } from '../-private/action-styles.ts';
import type { Signature as IconSignature } from '../-private/components/link-or-button-icon';
import IconComponent from '../-private/components/link-or-button-icon.gts';

export interface WrButtonSignature {
  Element: HTMLButtonElement;
  Args: {
    /**
     * The look of the button (default: `primary`). The same names as WrAnchor
     * and WrLinkTo: `primary`, `primary-white-border`, `outlined`,
     * `outlined-mini`, `link`, `inverted-link`.
     */
    variant?: ActionVariant;
    icon?: IconSignature['Args']['icon'];
    ariaLabel?: string;
  };
  Blocks: {
    default: [];
  };
}

export default class WrButtonComponent extends Component<WrButtonSignature> {
  get styles() {
    return buttonStyles(this.args.variant ?? 'primary');
  }

  <template>
    <button
      type='button'
      class={{this.styles}}
      aria-label={{@ariaLabel}}
      ...attributes
    >
      <IconComponent @icon={{@icon}} />
      {{yield}}
    </button>
  </template>
}
